/**
 * Main draw loop
 */
export default function drawLoop() {}
